
<span [class]="alertClassNames">
    <span [class]="characterClassNames">{{typeDescriptorTranslateKey | translate}}</span>
</span>
